// What `up-on-accepted` would do, except that this application's CSP has no
// `unsafe-inline` for scripts. Unpoly rewrites an unverifiable callback attribute
// to `/* blocked */` and the layer then does nothing on acceptance — silently,
// with nothing in the console. A compiler is ordinary pack JavaScript and is not
// affected, so the intent travels as data instead:
//
//   data-accept-url    what to load when the overlay this link opened is accepted
//   data-accept-target where to put it
//
// The accepted value's id is appended to the URL. That is what carries the record
// created in the overlay back to the form that asked for it — the contact picker
// on a device reopens on the person who was just added, rather than leaving them
// to be searched for again.
up.compiler('[data-accept-url][data-accept-target]', (element) => {
  const onAccepted = (event) => {
    // The event bubbles from every overlay, so it has to be the one this link
    // opened. `layer.origin` is the element that opened it.
    if (!event.layer || event.layer.origin !== element) return

    const value = event.value
    const id = value && (typeof value === 'object' ? value.id : value)
    if (!id) return

    up.render({target: element.dataset.acceptTarget,
               url: element.dataset.acceptUrl + id})
  }

  document.addEventListener('up:layer:accepted', onAccepted)

  return () => document.removeEventListener('up:layer:accepted', onAccepted)
})
